export enum EInterviewSummaryStandardBlockMapToId {
  Introduction = 'LVv-4GVyCwhUkXUt96Hky',
  PersonalInformation = 'NnwLhZamEzUaiqFF0Hzp2',
  Legal = 'NnwTfZamEzUaiqFF0Hzk8',
  Occupation = 'UxS7r2TAco1Xr3kOlZV9S',
  ExperienceMotivation = '1QnVwuHopNxSw0QZbd6iY',
  RoleSpecific = 'LVv-4GVyCwGtYXUt96Hky',
  CertificatesLicenses = 'NnwLhZamEzUaiqFF0Hzk8',
  Behavioural = 'LUwJ3jKScVVr3UZtE2I-a',
  Education = 'sNWaU4OASe6LGZ2R496Zn',
  Languages = 'NnwPhZamEzUaiQFF0H9k8',
  Practical = 'I4MWNCFKd3ntr3AvpO3NJ',
  InterviewFlow = 'LVv-4GVyCFfHpX63r6Hky',
  ToDo = 'pJul27NTddJy74D09BGSY',
  NoShow = 'Lhv-4GgyCFftpX6326Hkf',
  UntitledBlock = 'RjCfKDesMJWq7CqD5bK21',
}

export enum EInterviewSummaryStandardBlockNames {
  Introduction = 'Introduction',
  PersonalInformation = 'Personal Information',
  Legal = 'Legal',
  Occupation = 'Occupation',
  ExperienceMotivation = 'Experience & Motivation',
  RoleSpecific = 'Role Specific',
  CertificatesLicenses = 'Certificates & Licenses',
  Behavioural = 'Behavioural Interview Questions',
  Education = 'Education',
  Languages = 'Languages',
  Practical = 'Practical',
  InterviewFlow = 'Interview Flow',
  ToDo = 'To Do',
  NoShow = 'No show',
  UntitledBlock = 'Untitled Block',
}

type TTemplateInterviewSummaryBlockDetail = {
  id: string;
  label?: string;
  deleted?: boolean;
};

export type TTemplateInterviewSummaryBlock = {
  id: string;
  name: string;
  details: TTemplateInterviewSummaryBlockDetail[];
};

export type TTemplateInterviewSummary = {
  // legacy
  block_ids?: string[];
  // legacy
  blocks?: Record<string, TTemplateInterviewSummaryBlock>;
  summary_blocks: TTemplateInterviewSummaryBlock[];
  approved?: boolean;
  approved_by?: string;
  approved_date?: Date;
};
